<ng-container *ngIf="supportedLanguages$ | async as supportedLanguages">
  <ng-container *ngIf="mainLanguages$ | async as mainLanguages">
    <ng-container *ngIf="currentLanguage$ | async as currentLanguage">
      <button
        class="body-4 bold"
        (click)="changeLanguage(language)"
        *ngFor="let language of mainLanguages"
        [class.active]="currentLanguage === language"
        data-analytics="footer_select-language"
        [attr.data-cy]="'language-button_' + language"
      >
        {{ language === 'ch' ? FRONTEND_LANGUAGE_LABELS[language] : (language | titlecase) }}
      </button>
      <button
        class="body-4 bold www"
        *ngIf="mainLanguages.length < supportedLanguages.length"
        (click)="isOpen = !isOpen"
        [class.active]="!mainLanguages.includes(currentLanguage)"
        data-analytics="footer_select-language"
        [attr.data-cy]="'language-button_www'"
      >
        <dap-lib-icon name="globe" [svgAriaLabel]="'globe'" iconSize="24" iconColor="dark-grey"></dap-lib-icon>
      </button>
      <ssc-layouted-vertical-overlay (closed)="isOpen = false" *ngIf="isOpen" [title]="''" [subtitle]="''">
        <div content>
          <button
            *ngFor="let language of supportedLanguages"
            class="body-4 bold"
            (click)="changeLanguage(language)"
            [class.active]="currentLanguage === language"
            data-analytics="footer_select-language"
            [attr.data-cy]="'language-button_' + language"
          >
            {{ FRONTEND_LANGUAGE_LABELS[language] | titlecase }}
          </button>
        </div>
      </ssc-layouted-vertical-overlay>
    </ng-container>
  </ng-container>
</ng-container>
